import { getRootEnv } from '@bringg-frontend/bringg-web-infra';
import { action, makeObservable } from 'mobx';

import ActionsConfiguration, { normalizeActionsConfiguration } from './actions-configuration';
import {
	ActionsConfigurationLevel,
	ActionsConfiguration as ActionsConfigurationEntity
} from '../../../types/common.consts';
import { actionFlowMap } from 'bringg-web/features/actions-data/action-data.consts';

export default class TaskConfiguration extends ActionsConfiguration {
	level = ActionsConfigurationLevel.ORDER;

	constructor(actionsConfiguration: ActionsConfigurationEntity) {
		super(actionsConfiguration);

		makeObservable(this, {
			delete: action
		});
	}

	update = () => {
		const updateParams = {
			title: this.title,
			action_data: normalizeActionsConfiguration(this.action_data, this.level),
			enable_automated_action_flow: actionFlowMap.get(this.action_flow_automation)
		};
		return getRootEnv().dashboardSdk.sdk.taskConfigurations.update(this.id, updateParams);
	};

	delete = () => {
		return getRootEnv().dashboardSdk.sdk.taskConfigurations.update(this.id, { action_data: [] });
	};
}
